import getIssues from '@/data/getIssues'
import getIssue from '@/data/getIssue'

export default {
    namespaced: true,
    state: {
        getIssues: { ...getIssues },
        getIssue: { ...getIssue },
        user: null,
    },
    getters: {
        getNewIdIssue(state) {
            return state.getIssues.data.getProject.issues.at(-1).id
        },
        getUser(state) {
            return state.user
        },
        getNextIssueCode(state) {
            const codes = []
            state.getIssues.data.getProject.issues.forEach(issue => codes.push(issue.code))
            codes.sort((a, b) => a - b)

            return codes[codes.length - 1] + 1
        },
    },
    mutations: {
        SET_USER(state, user) {
            state.user = {
                ...user,
                surname: '',
                id: 2,
                role: '-',
                image: null,
                address: null,
            }
        },
        DELETE_ISSUE(state, id) {
            delete state.getIssue[id]
            state.getIssues.data.getProject.issues = state.getIssues.data.getProject.issues.filter(issue => {
                return issue.id != id
            })
            let issueCount = {
                total: 0,
                open: 0,
                closed: 0,
                in_review: 0,
            }
            state.getIssues.data.getProject.issues.map((item, index) => {
                issueCount.total++
                issueCount[item.status]++
            })
            state.getIssues.data.getProject.issue_count = { ...issueCount }
            state.getIssues.data.getProject.issue_filter_results = { ...state.getIssues.data.getProject.issue_count }
        },
        MOVE_ISSUE(state, value) {
            state.getIssue[value.id].data.getIssue = {
                ...state.getIssue[value.id].data.getIssue,
                ...value,
            }
        },
        ADD_NEW_ISSUE(state, value) {
            let items = Object.keys(state.getIssue).map(key => {
                return key
            })
            const id = items.length > 0 ? Number(items.at(-1)) + 1 : Math.ceil(Math.random() * 1000)
            value.id = id
            state.getIssue[id] = { data: { getIssue: value } }
            state.getIssues.data.getProject.issues.push(value)
        },
        UPDATE_COUNTS(state, value) {},
        UPDATE_STATUS_ISSUES_COUNT(state, value) {
            state.getIssues.data.getProject.issues.map((issue, index) => {
                if (issue.id == value.issue.id) {
                    state.getIssues.data.getProject.issues[index].status = value.status
                    if (value.status == 'closed') state.getIssues.data.getProject.issues[index].closed_at = new Date().toLocaleDateString()
                    else state.getIssues.data.getProject.issues[index].closed_at = null
                }
            })
            let issueCount = {
                total: 0,
                open: 0,
                closed: 0,
                in_review: 0,
            }
            state.getIssues.data.getProject.issues.map((item, index) => {
                issueCount.total++
                issueCount[item.status]++
            })
            state.getIssues.data.getProject.issue_count = { ...issueCount }
            state.getIssues.data.getProject.issue_filter_results = { ...state.getIssues.data.getProject.issue_count }
        },
    },
}
